module.exports = __webpack_public_path__ + "img/ruanjian.480e6f33.jpg";